import React from 'react';

import BoreIcon from './bore.svg?react';

function FarmbotBoreIcon() {
  return <BoreIcon width={18} />;
}

export default FarmbotBoreIcon;
